import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('CONSUMER_VOUCHER', [
    'VIEW',
    'INFO',
    'HEADER',
    'FILTER_FORM'
])
